<template>
  <div v-if="autoren != null && autoren.autoren && typeof getAutor() != 'undefined'">
    <h1 class="text-center">{{getAutor().vorname + ' ' + getAutor().nachname}}</h1>
    <v-divider></v-divider>
    <div id="admin" v-if="getUserMail() == 'leonard.storcks@pm.me'">
      <h2>Admin-Funktionen</h2>
      <div class="columns">
        <div class="column">
          <v-text-field class="ma-0" v-model="nmail" label="E-Mail Adresse des Nutzers" single-line></v-text-field>
        </div>
        <div class="column">
          <v-btn block outlined @click="whitelistUser()">Nutzer auf Whitelist</v-btn>
        </div>
      </div>
      <v-divider></v-divider>
    </div>
    <h3>Über mich</h3>
    <el-tiptap v-model="autor.bio" :extensions="extensions"/>
    <v-divider></v-divider>
    <h3>Weblinks</h3>
    <v-list v-if="links && links.length != 0" class="mb-3">
        <v-list-item v-for="link in links" :key="link.link">
            <v-list-item-title>{{link.title}}</v-list-item-title>
            <v-list-item-action @click="delLink(link.link)"><v-icon color="#e74c3c">{{del}}</v-icon></v-list-item-action>
        </v-list-item>
    </v-list>
    <v-btn outlined block @click="dialog = true" color="#1abc9c">Weblink hinzufügen</v-btn>
    <v-divider></v-divider>
    <v-btn block outlined @click="save()" color="#2ecc71">Speichern</v-btn>
    <v-divider></v-divider>
    <v-btn block outlined @click="logout()" color="#e74c3c">Logout</v-btn>
    <v-snackbar color="#2ecc71" v-model="snackbar">Gespeichert
      <v-btn dark :href="'https://wach.lernzettel.org/users/' + 'leonard-storcks'" target="_blank">Ansehen</v-btn>
    </v-snackbar>
    <v-snackbar color="#2ecc71" v-model="snackbaru">Nutzer auf die Whitelist gesetzt
    </v-snackbar>
    <v-dialog v-model="dialog" max-width="350">
        <v-card>
          <v-card-title class="headline">Weblink</v-card-title>
          <v-text-field class="ml-6 mr-6" v-model="title" label="Titel" single-line></v-text-field>
          <v-text-field class="ml-6 mr-6" v-model="link" label="URL" single-line></v-text-field>
          <v-card-actions>
            <v-btn color="green darken-1" text @click="dialog = false; addLink()">Weiter</v-btn>
            <v-btn color="red darken-1" text @click="dialog = false; title = ''">Schließen</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  Doc,
  Text,
  Paragraph,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Link,
  Image,
  CodeBlock,
  Blockquote,
  ListItem,
  BulletList,
  OrderedList,
  TodoItem,
  TodoList,
  TextAlign,
  Indent,
  LineHeight,
  HorizontalRule,
  HardBreak,
  TrailingNode,
  History,
  Table,
  TableHeader,
  TableCell,
  TableRow,
  FormatClear,
  TextColor,
  TextHighlight,
  Preview,
  Fullscreen
} from 'element-tiptap';

import { db } from '../db'
import { fb } from '../db'

const blog = db.collection('blog');
const shared = db.collection('shared');
const vault = db.collection('vault');
import { mdiDelete} from '@mdi/js'

export default {
  watch: {
      $route: {
        immediate: true,
        handler(to, from) {
          this.$bind('autoren', shared.doc('autoren'));
          this.$Progress.finish()
        }
      }
  },
  methods: {
    save: function() {
      blog.doc('autoren').get().then((autoren) => {
        var foundIndex = autoren.data().autoren.findIndex(x => x.mail == this.autor.mail);
        var update = autoren.data().autoren
        this.autor.links = this.links
        update[foundIndex] = this.autor
        blog.doc('autoren').set({autoren: update})
        this.snackbar = true
      })
    },
    whitelistUser: function() {
      vault.doc('whitelist').get().then((whitelist) => {
        var wl = []
        if(!(whitelist.data() == null || typeof whitelist.data().whitelist == 'undefined')) {
          wl = whitelist.data().whitelist
        }
        wl.push(this.nmail)
        vault.doc('whitelist').set({whitelist: wl})
        this.nmail = ''
        this.snackbaru = true
      })
    },
    getUserMail: function() {
        return fb.auth().currentUser.email
    },
    getAutor: function() {
        if(typeof this.autor.vorname == 'undefined'){
          this.autor = this.autoren.autoren.find(x => x.mail == this.getUserMail())
          if(typeof this.autor.links != 'undefined'){
            this.links = this.autor.links
          }
          return this.autor
        } else {
          return this.autor
        }
    },
    logout: function() {
      fb.auth().signOut().
      catch(function(error) {
        console.log(error)
      }).then(() => this.$router.push('/'));
    },
    toSlug: function(str){
        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();
        // remove accents, swap ñ for n, etc
        var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
        var to   = "aaaaaeeeeeiiiiooooouuuunc------";
        for (var i=0, l=from.length ; i<l ; i++) {
          str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }
        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
          .replace(/\s+/g, '-') // collapse whitespace and replace by -
          .replace(/-+/g, '-'); // collapse dashes
        return str;
    },
    addLink: function(){
        this.links.push({title: this.title, link: this.link})
        this.title = ""
        this.link = ""
    },
    delLink: function(link){
        this.links = this.links.filter(item => item.link !== link)
    }
  },
  mounted: function(){
    if(this.$route.params.lernzettel !== ''){
      this.$bind('autoren', shared.doc('autoren'));
      this.$Progress.finish()
    }
  },
  data: () => ({
    del: mdiDelete,
    snackbar: false,
    nmail: '',
    dialog: false,
    links: [],
    title: "",
    link: "",
    snackbaru: false,
    autoren: {},
    autor: {},
    content: "",
    extensions: [
      new Doc(),
      new Text(),
      new Paragraph(),
      new Heading({ level: 5 }),
      new Bold({ bubble: true }), // render command-button in bubble menu.
      new Underline(),
      new Italic(),
      new Strike(),
      new ListItem(),
      new BulletList(),
      new OrderedList(),
      new Link(),
      new Image(),
      new CodeBlock(),
      new Blockquote(),
      new ListItem(),
      new BulletList(),
      new OrderedList(),
      new TodoItem(),
      new TodoList(),
      new TextAlign(),
      new Indent(),
      new LineHeight(),
      new HorizontalRule(),
      new HardBreak(),
      new TrailingNode(),
      new History(),
      new Table(),
      new TableHeader(),
      new TableCell(),
      new TableRow(),
      new FormatClear(),
      new TextColor(),
      new TextHighlight(),
      new Preview(),
      new Fullscreen()
    ]
  })
}
</script>